import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Mail, Phone, MapPin } from 'lucide-react';

export const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#D4AF37]/20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_learn-finance-5/artifacts/u8xwnrlt_Logo_Geldgymnasium_riesig.png" 
                  alt="GeldGymnasium Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h1 className="text-lg sm:text-2xl font-bold bg-gradient-to-r from-[#D4AF37] to-[#B8960C] bg-clip-text text-transparent">
                  GeldGymnasium
                </h1>
                <p className="text-xs text-gray-600 hidden sm:block">Finanzielle Bildung</p>
              </div>
            </div>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white text-sm sm:text-base px-3 sm:px-4"
            >
              <ArrowLeft className="w-4 h-4 mr-1 sm:mr-2" />
              <span className="hidden sm:inline">Zurück zur Startseite</span>
              <span className="sm:hidden">Zurück</span>
            </Button>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] bg-clip-text text-transparent">
            Impressum
          </h1>

          <div className="space-y-8">
            {/* Verantwortlich für den Inhalt */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Verantwortlich für den Inhalt
              </h2>
              <p className="text-sm text-gray-600 mb-4">nach § 55 Abs. 2 RStV:</p>

              <div className="bg-gradient-to-r from-[#D4AF37]/10 to-[#FFD700]/10 border-l-4 border-[#D4AF37] p-6 rounded-r-lg">
                <p className="font-bold text-gray-900 mb-3">Tempel Akademie des Erfolges GmbH</p>
                <p className="text-gray-700 mb-1">Geschäftsführer Jan Dembny</p>
                
                <div className="mt-4 space-y-2">
                  <div className="flex items-start space-x-3">
                    <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">Marienstr. 15, D-01067 Dresden</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Phone className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                    <a href="tel:+4917632819049" className="text-gray-700 hover:text-[#D4AF37] transition-colors">
                      +49 (0) 176 32819049
                    </a>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Mail className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                    <a href="mailto:info@geldgymnasium.de" className="text-gray-700 hover:text-[#D4AF37] transition-colors">
                      info@geldgymnasium.de
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* Bildmaterial */}
            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Bildmaterial</h3>
              <p className="text-gray-700">
                © <a href="https://www.pixabay.com" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:underline">www.pixabay.com</a>
              </p>
            </section>

            {/* EU-Streitschlichtung */}
            <section className="bg-blue-50 border border-blue-200 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Hinweis auf EU-Streitschlichtung</h3>
              <p className="text-gray-700 mb-3">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a 
                  href="https://ec.europa.eu/consumers/odr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#D4AF37] hover:underline"
                >
                  ec.europa.eu/consumers/odr
                </a>
              </p>
              <p className="text-gray-700 mb-3">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle im Sinne des Verbraucherstreitbeilegungsgesetzes teilzunehmen.
              </p>
              <p className="text-gray-700">
                Unsere E-Mail-Adresse lautet{' '}
                <a href="mailto:info@geldgymnasium.de" className="text-[#D4AF37] hover:underline">
                  info@geldgymnasium.de
                </a>
              </p>
            </section>

            {/* Haftungsausschluss */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Haftungsausschluss</h2>

              <div className="space-y-6 text-gray-700 leading-relaxed">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Haftung für Inhalte</h3>
                  <p>
                    Als Dienstanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Dienstanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Haftung für Links</h3>
                  <p>
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Urheberrecht</h3>
                  <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Widerspruch Werbe-Mails</h3>
                  <p>
                    Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.
                  </p>
                </div>
              </div>
            </section>

            {/* Quelle */}
            <section className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Quelle:{' '}
                <a 
                  href="https://www.e-recht24.de" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#D4AF37] hover:underline"
                >
                  https://www.e-recht24.de
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
